import { PaymentService } from "@/api";
import { useMutation } from "@tanstack/react-query";

export const useRecoverWithSlip = () => {
    const result = useMutation({
        mutationFn: ({ slip }: { slip: File }) => PaymentService.paymentControllerRecover({ slip }),
    });

    return result;
}
